<template>
  <div :class="['edit-info', role === 0 ? 'my-info' : '']" v-if="infos">
    <div class="head-name">
      <van-uploader
        v-model="head"
        :preview-image="false"
        :max-count="2"
        :before-read="headBeforeRead"
      >
        <div class="head-name-infos">
          <div class="img-show">
            <m-loading :loading="headLoading" :hasTxt="false" />
            <img v-if="infos && infos.head" :src="infos.head" alt="" />
            <img v-else src="../../assets/images/home/unuser_head.svg" alt="" />
          </div>
          <div class="change-head-btn">
            <span>点击头像更换</span>
            <!-- <van-icon name="arrow" size="20" color="#cbcbcb" /> -->
          </div>
        </div>
      </van-uploader>
      <!-- <van-uploader
        v-model="head"
        :preview-image="false"
        :max-count="2"
        :before-read="headBeforeRead"
        :after-read="headAfterRead"
      >
        <div class="change-head-btn">
          <span>更改头像</span>
          <van-icon name="arrow" size="20" color="#cbcbcb" />
        </div>
      </van-uploader> -->
      <div class="name" @click="changeNameView = true">
        <van-loading v-if="nkNameLoading" size="24px" vertical
          >更新中...</van-loading
        >
        <span v-else>{{ infos.name }}</span>
        <img src="../../assets/images/mine/edit-pen.svg" alt="" />
      </div>
    </div>
    <div class="infos-kv-list" v-if="infos.infosList && role !== 0">
      <!-- <div v-for="(item, i) in infos.infosList" :key="i">
        <van-cell :title="item.name">
          <template #default v-if="item.type === 'tags'">
            <div>
              <van-tag
                v-for="(tag, j) in item.child"
                :key="j"
                type="primary"
                size="large"
                >{{ tag }}</van-tag
              >
            </div>
          </template>
          <template #default v-else-if="item.type !== 'long'">
            <img v-if="item.img" :src="item.img" alt="" />{{ item.value }}
          </template>
        </van-cell>
        <span v-if="i !== infos.infosList.length - 1"></span>
        <div class="expert-intro" v-if="item.type === 'long'">
          {{ item.value }}
        </div>
      </div> -->

      <van-cell-group v-for="(item, i) in infos.infosList" :key="i">
        <div v-for="(cell, i) in item" :key="i" :class="cell.type">
          <van-cell :title="cell.name">
            <template #default v-if="cell.type === 'tags'">
              <div>
                <van-tag
                  v-for="(tag, j) in cell.child"
                  :key="j"
                  type="primary"
                  size="large"
                  >{{ tag }}</van-tag
                >
              </div>
            </template>
            <template #default v-else-if="cell.type !== 'long'">
              <img v-if="cell.img" :src="cell.img" alt="" />{{ cell.value }}
            </template>
          </van-cell>
          <!-- <span v-if="i !== infos.infosList.length - 1"></span> -->
          <div class="expert-intro" v-if="cell.type === 'long'">
            {{ cell.value }}
          </div>
        </div>
      </van-cell-group>
    </div>
    <div class="save-btn" v-if="role === 0">
      <van-button
        size="large"
        color="linear-gradient(to right, #5DD682, #5AFF8E)"
        round
        :loading="subLoading"
        @click="save"
        >保存</van-button
      >
    </div>
    <div class="tips" v-if="role === 1">
      专家信息如需更改请联系上级赛事组织单位
    </div>
    <div class="tips" v-if="role === 2">
      报名服务单位认证信息如需更改请联系上级赛事组织单位
    </div>
    <van-dialog
      v-model="changeNameView"
      title="请输入新的昵称"
      show-cancel-button
      @confirm="submitNewName"
    >
      <el-input
        v-model="newName"
        style="margin: 20px auto 40px auto; width: 210px"
        placeholder="请输入内容"
      />
    </van-dialog>
    <van-action-sheet
      v-model="changeHeadView"
      :actions="[
        { name: '拍照', type: 0 },
        { name: '从本地上传', type: 1 },
        { name: '取消', type: 2 }
      ]"
      @select="onSelect"
    />
    <Crop
      :popup.sync="compressShow"
      :img="compressImg"
      @close="cancelUpload"
      @getImageData="uploadHead"
    />
  </div>
</template>

<script>
// 当角色为选手，点击保存才保存头像和名称
import { updNickName, updUserImg } from "@/utils/api/user";
import { checkUploadFile, dateFormat } from "@/utils/tool";
import { mapActions } from "vuex";
import Crop from "@/components/pub/CompressCrop.vue";
export default {
  components: {
    Crop
  },
  data() {
    return {
      // 信息
      infos: null,
      // 弹出修改名字框
      changeNameView: false,
      changeHeadView: false,
      // 新名字
      newName: "",
      // 更新名字loading
      nkNameLoading: false,
      // 角色
      role: -1,
      // 用户缓存信息
      dataInfo: {},
      // 头像
      head: [],
      //
      headImgFile: null,
      // 上传时loading
      headLoading: false,
      // 按钮保存loading
      subLoading: false,
      compressShow: false,
      compressImg: ""
    };
  },
  methods: {
    ...mapActions(["setUserInfo"]),
    getRoleInfo() {
      this.role = this.$store.state.role;
      const infos = this.$store.state.userInfo;
      this.dataInfo = this.$store.state.userInfo;
      this.newName = infos.nickName;
      this.infos = {
        name: infos.nickName,
        head: infos.userImg,
        infosList:
          this.role === 1
            ? [
                [
                  {
                    name: "真实姓名",
                    value: infos.t.realName || "-"
                  },
                  {
                    name: "出生日期",
                    value:
                      dateFormat(
                        Date.parse(new Date(infos.t.birthday)),
                        "YYYY-MM-DD"
                      ) || "-"
                  },
                  {
                    name: "性别",
                    value: infos.t.sex ? "女" : "男"
                  },
                  {
                    name: "专业",
                    value: "姓名",
                    type: "tags",
                    child: infos.t.majors.split(",")
                  }
                ],
                [
                  {
                    name: "手机号码",
                    value: infos.t.tel || "-"
                  },
                  {
                    name: "通讯地址",
                    value: infos.t.contactAddress || "-"
                  }
                ],
                [
                  {
                    name: "专家简介",
                    value: infos.t.synopsis || "-",
                    type: "long"
                  }
                ]
              ]
            : [
                [
                  {
                    name: "报名服务单位名称",
                    value: infos.t.name || "-"
                  },
                  {
                    name: "报名服务单位地址",
                    value: infos.t.contactAddress || "-"
                  },
                  {
                    name: "报名服务单位简介",
                    value: infos.t.synopsis || "-",
                    type: "long"
                  }
                ],
                [
                  {
                    name: "联系人",
                    value: infos.t.personCharge || "-"
                  },
                  {
                    name: "手机号",
                    value: infos.t.contactsTel || "-"
                  },
                  {
                    name: "微信号",
                    value: infos.t.wxAccounts || "-"
                  }
                ]
              ]
      };
    },
    submitNewName() {
      if (this.role === 0) {
        this.infos.name = this.newName;
      } else {
        this.nkNameLoading = true;
        updNickName({ nickName: this.newName }).then((res) => {
          if (res.success) {
            this.$root.$toast.success("修改成功");
            this.infos.name = this.newName;
            this.nkNameLoading = false;
            this.dataInfo.nickName = this.newName;
            this.setUserInfo(this.dataInfo);
          }
        });
      }
    },
    onSelect(item) {
      const key = item.type;
      switch (key) {
        // 拍照
        case 0:
          this.changeHeadView = false;
          break;
          // 上传
        case 1:
          this.changeHeadView = false;
          break;
          // 取消
        case 2:
          this.changeHeadView = false;
          break;
          // 取消
        default:
          this.changeHeadView = false;
          break;
      }
    },
    async save() {
      this.subLoading = true;
      if (this.newName) {
        updNickName({ nickName: this.newName }).then((res) => {
          if (res.success) {
            this.$root.$toast.success({
              message: "修改成功",
              duration: 2000,
              onClose: () => {
                this.$router.push("/mine/index");
              }
            });
            this.dataInfo.nickName = this.newName;
            this.setUserInfo(this.dataInfo);
            this.subLoading = false;
          }
        });
      }
      if (this.head.length > 0) {
        const file = this.headImgFile;
        let formData = new FormData();
        formData.append("multipartFile", file);
        updUserImg(formData).then((res) => {
          if (res.success) {
            this.$root.$toast.success({
              message: "修改成功",
              duration: 2000,
              onClose: () => {
                this.$router.push("/mine/index");
              }
            });
            this.dataInfo.userImg = res.data;
            this.setUserInfo(this.dataInfo);
            this.subLoading = false;
          }
        });
      }
    },
    cancelUpload() {
      this.compressShow = false;
      this.head = [];
    },
    headBeforeRead(file) {
      // const success = checkUploadFile({ file }, (msg) => {
      //   this.$root.$toast.fail(msg);
      // });
      // if (success) {
      //   this.head.splice(0, 1);
      // }
      // return success;
      this.compressImg = URL.createObjectURL(file);
      this.head = [
        {
          url: "",
          status: "uploading",
          message: "图片编辑...",
          name: file.name
        }
      ];
      this.$forceUpdate();
      this.compressShow = true;
    },
    headAfterRead() {
      const file = this.headImgFile;
      if (this.role !== 0) {
        this.headLoading = true;
        let formData = new FormData();
        formData.append("multipartFile", file);
        updUserImg(formData).then((res) => {
          if (res.success) {
            this.headLoading = false;
            this.$root.$toast.success("修改成功");
            this.infos.head = res.data;
            this.dataInfo.userImg = res.data;
            this.setUserInfo(this.dataInfo);
          }
        });
      } else {
        this.head = [
          {
            url: this.infos.head,
            status: "done",
            name: file.name
          }
        ];
      }
    },
    // 上传头像
    async uploadHead(file, src) {
      const pass = checkUploadFile({ file, size: 3 }, (msg) => {
        this.$root.$toast.fail(msg);
        this.head = [];
      });
      if (!pass) {
        return;
      }
      this.headImgFile = file;
      this.infos.head = src;
      this.headAfterRead();
    }
  },
  mounted() {
    this.getRoleInfo();
  }
};
</script>

<style lang="scss" scoped>
.edit-info {
  height: 100%;
  background-color: #f2f2f2;
  &.my-info {
    background-color: #f2f2f2;
  }
  .head-name {
    height: 78px;
    background-color: #fff;
    padding: 0 20px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .head-name-infos {
      display: flex;
      align-items: center;
      .img-show {
        position: relative;
        width: 50px;
        height: 50px;
        border-radius: 25px;
        overflow: hidden;
        img {
          width: 50px;
          height: 50px;
          border-radius: 25px;
        }
      }
      .change-head-btn {
        display: flex;
        align-items: center;
        height: 78px;
        margin-left: 8px;
        span {
          font-size: 14px;
          color: #999;
        }
      }
    }
    .name {
      margin-left: 10px;
      span {
        font-size: 14px;
        color: #666;
      }
      img {
        width: 10px;
        height: 12px;
        margin-left: 3px;
      }
    }
  }
  .infos-kv-list {
    .van-cell__title {
      text-align: left;
    }
    .van-cell {
      &:last-child {
        &::after {
          border-bottom: none;
        }
      }
    }
    .tags {
      .van-cell__value {
        flex: unset;
        width: 70%;
      }
    }
    .van-tag {
      height: 32px;
      margin-left: 10px;
      border-radius: 4px;
      border: #f2f2f2;
      min-width: 60px;
      background-color: #ecf5ff;
      color: #666;
      font-size: 12px;
      text-align: center;
      display: inline-block;
      line-height: 26px;
      margin-bottom: 5px;
    }
    .expert-intro {
      width: 335px;
      margin: 10px auto;
      min-height: 100px;
      border-radius: 3px;
      border: 1px solid #f2f2f2;
      padding: 10px;
      font-size: 12px;
      color: #666;
      line-height: 16px;
      text-align: left;
      text-indent: 24px;
      background-color: #f2f2f2;
    }
  }
  .tips {
    font-size: 12px;
    color: #999;
    margin-top: 10px;
  }
  .save-btn {
    width: 290px;
    margin: 0 auto;
    margin-top: 332px;
    .van-button {
    }
  }
}
</style>
<style lang="scss">
.edit-info {
  .save-btn {
    .van-button {
      border-radius: 16px;
      width: 254px;
      height: 32px;
    }
  }
  .van-cell-group {
    margin-top: 20px;
    .long {
      padding-bottom: 10px;
    }
  }
}
</style>
